import Request from "@/Request";

export function login(payload) {
  return Request({
    url: "/auth/login",
    method: "post",
    data: payload,
  });
}

export function sendResetPasswordCode(payload) {
  return Request({
    url: "/auth/send-code",
    method: "post",
    data: payload,
  });
}

export function resetPassword(payload) {
  return Request({
    url: "/auth/reset-password",
    method: "post",
    data: payload,
  });
}

export function logout() {
  return Request({
    url: "/auth/logout",
    method: "post",
  });
}
